import tw, { styled } from 'twin.macro'

const ArticleHeading = styled.h2`
  ${tw`font-heading mb-4 md:mb-8 text-2xl md:text-4xl lg:text-4xl`}
`

export default ArticleHeading
